function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, String) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'report-header-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'report-header-content': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'report-header-title': true
            },
          }, [__vjadeSafeCode($attr(`title`))]));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'report-header-description': true
            },
          }, [__vjadeSafeCode($attr(`description`))]));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("slot"));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;